import { SkeletonComponent } from '@design-system';
import React from 'react';

export const CauseriesTalkFilesSkeleton: React.FC = () => {
    return (
        <div style={{ marginTop: '16px' }}>
            <SkeletonComponent
                key={'video'}
                count={1}
                style={{
                    height: '258px',
                    width: 'calc(100% - 32px)',
                    borderRadius: '18px',
                    margin: '-2px auto',
                    display: 'block'
                }}
            />
            <SkeletonComponent
                key={'files'}
                count={1}
                style={{
                    height: '150px',
                    width: 'calc(100% - 32px)',
                    borderRadius: '18px',
                    margin: '-2px auto',
                    display: 'block'
                }}
            />
        </div>
    );
};
